import { Dropdown } from "antd"
import PropTypes from "prop-types"
import React, { useEffect, useMemo, useState } from "react"
import Geocode from "react-geocode"
import { FiFilter } from "react-icons/fi"
import styled from "styled-components"

import StyledAppButton from "../../../../_shared/components/AppButton"
import FormInput from "../../../../_shared/components/FormItems/FormInput"
import FormSelect from "../../../../_shared/components/FormItems/FormSelect"
import { useStateValue } from "../../../../_shared/context/AppStateStore"
import usePaginatedRestResource from "../../../../_shared/hooks/usePaginatedRestResource"

// ----------------------------------------------------------------------------

function _TenanciesFilter(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, onFilter } = props

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    const [{ token }] = useStateValue()

    const [filters, setFilters] = useState({
        status: "submitted",
        createdBy: null,
    })
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState()

    const [userSearch, setUserSearch] = useState("")

    const [users, , , , , handleFiltersChange] = usePaginatedRestResource(
        "/users",
        token,
        {
            filters: { role: "agency" },
            pageSize: 50,
        }
    )

    const userOptions = useMemo(() => {
        return users?.map((user) => ({
            label: user.businessName,
            value: user.id,
        }))
    }, [users])

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    const statusOptions = useMemo(() => {
        return [
            { label: "Tutti", value: null },
            { label: "In attesa di conferma", value: "submitted" },
            { label: "Accettato", value: "accepted" },
            { label: "Rifiutato", value: "rejected" },
        ]
    }, [])

    // -------------------------------------
    // Effects
    // -------------------------------------

    useEffect(() => {
        if (userSearch && userSearch.length >= 3) {
            handleFiltersChange({ role: "agency", search: userSearch })
        } else {
            handleFiltersChange({ role: "agency", search: null })
        }
        // eslint-disable-next-line
    }, [userSearch])

    // -------------------------------------
    // Component functions
    // -------------------------------------

    async function handleConfirm() {
        onFilter &&
            onFilter({
                ...filters,
            })
        setVisible(false)
    }

    function updateFilters(field) {
        return (value) => setFilters({ ...filters, [field]: value })
    }

    function renderDropdown() {
        return (
            <div className="filter-dropdown">
                <FormSelect
                    label="Stato"
                    value={filters.status}
                    onChange={updateFilters("status")}
                    className="field"
                    options={statusOptions}
                    paddingHorizontal={10}
                />
                <FormSelect
                    label="Agenzia gestore"
                    value={filters.createdBy}
                    onChange={updateFilters("createdBy")}
                    className="field"
                    options={userOptions}
                    searchValue={userSearch}
                    onSearch={setUserSearch}
                    paddingHorizontal={10}
                />
                <StyledAppButton
                    uxType="primary"
                    className="confirm-btn"
                    onClick={handleConfirm}
                    loading={loading}
                >
                    Applica filtri
                </StyledAppButton>
            </div>
        )
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className}`}>
            <Dropdown
                getPopupContainer={(node) => node.parentElement}
                overlay={renderDropdown}
                trigger="click"
                // don't close dropdown when item is clicked
                visible={visible}
                onVisibleChange={(newState) => setVisible(newState)}
            >
                <div className="filter-selector">
                    <div className="filter-icon">
                        <FiFilter />
                    </div>
                    <div className="filter-label">Ricerca</div>
                </div>
            </Dropdown>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_TenanciesFilter.propTypes = {
    className: PropTypes.string.isRequired,
    onFilter: PropTypes.func,
}

_TenanciesFilter.defaultProps = {}

// ----------------------------------------------------------------------------

const TenanciesFilter = styled(_TenanciesFilter)`
    & {
        margin-bottom: 30px;

        .ant-select-selection-search input {
            padding: 0px 10px !important;
        }

        .filter-selector {
            height: 48px;
            width: 250px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0px 15px;
            border-radius: 6px;
            border: 1px solid black;
            cursor: pointer;

            .filter-icon {
                display: flex;
                align-items: center;
                justify-content: center;
                svg {
                    width: 20px;
                    height: 20px;
                }
            }
            .filter-label {
                font-size: 16px;
                font-weight: 700;
                margin-left: 10px;
            }
        }
        .filter-dropdown {
            width: 100%;
            background-color: white;
            box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.2);
            padding: 10px;
            border-radius: 10px;

            display: flex;
            align-items: center;
            flex-direction: column;

            .field {
                width: 100%;
                margin-bottom: 15px;
            }

            .confirm-btn {
                margin-top: 10px;
                width: 100%;
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default TenanciesFilter
